import React from 'react';
import { DidomiSDK } from '@didomi/react';
import { useQuery } from '@apollo/client';
import { apiKey } from './didomiConfig';
import { createRoot } from 'react-dom/client';
import NoticeHTML from './noticeHTML';
import SpanishNoticeHTML from './noticeHTML_ES';
import { INITIAL_QUERY } from '../query';
import { noticeID } from '../constants';
import { hashUserId } from '../utils/sha256';
import { MarketplaceProvider, TolgeeProvider, useMarketplace } from '@rakutenfrance/tolgee-provider';
import { publicRuntimeConfig } from '@rakutenfrance/config-service';
const DidomiComponent = ({ onConsentChanged, didomiNoticeId = 'TbzZzrtx', onReady, isStorybook, marketplaceOverrideForStorybook, }) => {
    var _a;
    const { data, loading } = useQuery(INITIAL_QUERY);
    const { marketplace } = useMarketplace(['fr', 'es']);
    const handleReady = (result) => {
        result.syncUser();
        if (onReady) {
            onReady();
        }
    };
    const renderNoticeHTML = (element) => {
        const root = createRoot(element);
        const currentMarketplace = isStorybook ? marketplaceOverrideForStorybook : marketplace;
        if (currentMarketplace === 'es') {
            root.render(React.createElement(SpanishNoticeHTML, { noticeText: "" }));
        }
        else {
            root.render(React.createElement(NoticeHTML, { noticeText: "" }));
        }
    };
    if (loading || !marketplace) {
        return null;
    }
    const getHashedUserId = () => {
        var _a;
        if ((_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.userId) {
            try {
                return hashUserId(data.profile.userId.toString(), process.env.DIDOMI_SECRET);
            }
            catch (error) {
                console.error('Failed to hash user ID:', error);
                return '';
            }
        }
        return '';
    };
    const config = {
        notice: {
            content: {
                html: {
                    fr: renderNoticeHTML,
                    en: renderNoticeHTML,
                    es: renderNoticeHTML,
                },
            },
        },
        languages: {
            enabled: ['fr', 'es'],
            default: isStorybook ? marketplaceOverrideForStorybook : marketplace,
        },
        sync: {
            enabled: true,
            delayNotice: true,
            frequency: 21600,
        },
    };
    return (React.createElement(DidomiSDK, { apiKey: apiKey, config: typeof data === 'undefined' || ((_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.userId) === undefined
            ? config
            : Object.assign(Object.assign({}, config), { user: {
                    organizationUserId: data.profile.userId.toString(),
                    organizationUserIdAuthDigest: getHashedUserId(),
                    organizationUserIdAuthSid: 'hashingse-EF4Gmy7x',
                    organizationUserIdAuthAlgorithm: 'hash-sha256',
                } }), iabVersion: 2, onConsentChanged: onConsentChanged, noticeId: isStorybook ? 'TbzZzrtx' : didomiNoticeId || noticeID, onReady: handleReady }));
};
const DidomiWrapper = ({ onConsentChanged, didomiNoticeId = 'TbzZzrtx', onReady, isStorybook, marketplaceOverrideForStorybook, }) => {
    var _a, _b, _c;
    return (React.createElement(TolgeeProvider, { ns: ['didomi'], apiKey: (_b = (_a = publicRuntimeConfig.tolgee) === null || _a === void 0 ? void 0 : _a.apiKey) === null || _b === void 0 ? void 0 : _b['next-common'], apiUrl: (_c = publicRuntimeConfig.tolgee) === null || _c === void 0 ? void 0 : _c.apiUrl },
        React.createElement(MarketplaceProvider, null,
            React.createElement(DidomiComponent, { onConsentChanged: onConsentChanged, didomiNoticeId: didomiNoticeId, onReady: onReady, isStorybook: isStorybook, marketplaceOverrideForStorybook: marketplaceOverrideForStorybook }))));
};
export { DidomiWrapper as Didomi };
